<template>
  <h2 class="block-title">
    <span v-html="title"></span>
    <component v-if="alphabet" :is="alphabetComponent" :color="colorScheme.second" />
  </h2>
</template>

<script>
import LpAlphabetProfile from '@/utvStore/components/recommend/lp/partials/LpAlphabetProfile'
import LpAlphabetFortuneTelling from '@/utvStore/components/recommend/lp/partials/LpAlphabetFortuneTelling'
import LpAlphabetReviews from '@/utvStore/components/recommend/lp/partials/LpAlphabetReviews'

export default {
  name: 'BlockTitle',
  components: {
    LpAlphabetProfile,
    LpAlphabetFortuneTelling,
    LpAlphabetReviews,
  },
  props: {
    title: String,
    colorScheme: Object,
    alphabet: String,
  },
  computed:{
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
      }
    },
    alphabetComponent() {
      return `lp-alphabet-${this.alphabet}`
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../../../../../sass/commons/commonVariables.scss";

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);

.block-title {
  margin: 0 0 60px;
  font-weight: bold;
  font-size: 26px;
  line-height: 1;
  text-align: center;
  color: $l_col_keycolor;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/partials/LpTitle.vue